import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { CellContext } from '@tanstack/react-table';
import { Link, generatePath } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface EmspBoRfidBadgeOrderListOrderNumberCellProps
  extends CellContext<
    BackOfficeRfidBadgeOrderModel,
    BackOfficeRfidBadgeOrderModel['orderNumber']
  > {}

export const EmspBoRfidBadgeOrderListOrderNumberCell = (
  props: EmspBoRfidBadgeOrderListOrderNumberCellProps,
): React.JSX.Element => {
  const { getValue, row } = props;

  return (
    <Link
      to={generatePath(APP_PATH.EMSP_BO_RFID_BADGE_ORDER.DETAILS, {
        id: row.original.id,
      })}>
      <Text truncate>{getValue()}</Text>
    </Link>
  );
};
